export { default as localizationClient } from './client';
